import React from 'react'
import { getPageMargins } from '../../config/GlobalSettings';
import { GetEBoolName } from '../../enumCollections/EBool';
import { ContactViewS } from '../Global/Elements/ContactViewS';
import { ProductionUnitViewS } from '../Global/Elements/ProductionUnitViewS';
import { ProductViewS } from '../Global/Elements/ProductViewS';
import { WarehouseViewS } from '../Global/Elements/WarehouseViewS';
import { PrintBranding } from './PrintBranding';


export const ProductDistributionPrint = React.forwardRef((props, ref) => {
    const data = props.printData
    return (
        <div ref={ref}>
            <style type="text/css">
                {getPageMargins()}
            </style>
            {
                data &&
                <PrintBranding printName="Product Distribution" date={data.onDate} id={data.id}>
                    {
                        data &&
                        <div className="row">
                            <div className="col-xs-12">

                                <table style={{ width: "100%" }} className="table-bordered-dark">
                                    <tbody>
                                        <tr >
                                            <td>Contact</td>
                                            <td>
                                                <ContactViewS item={data.contact} uid={"CX1"} />
                                            </td>
                                            <td>
                                                <span className="pull-right">
                                                    <WarehouseViewS item={data.warehouse} />
                                                </span>
                                            </td>
                                        </tr>

                                        <tr >
                                            <td>Production</td>
                                            <td colSpan={2}>
                                                <ProductionUnitViewS item={data.productionUnit} />
                                            </td>
                                        </tr>

                                        <tr >
                                            <td>Product</td>
                                            <td colSpan={2}>
                                                <ProductViewS item={data.product} uid={"PPX1"} />

                                            </td>
                                        </tr>

                                        <tr >
                                            <td>Given Product</td>
                                            <td colSpan={2}>
                                                <ProductViewS item={data.givenProduct} uid={"PPX1"} />

                                            </td>
                                        </tr>
                                        <tr >
                                            <td>Quantity</td>
                                            <td colSpan={2}>{data.quantity} {data.unit}</td>
                                        </tr>
                                        <tr>
                                            <td>Order</td>
                                            <td colSpan={2}>
                                                {data.isOrder == 1 ? (data.order ?
                                                    <>
                                                        Order No: <b>{data.orderId}</b>, Order To: <b>{data.order.toContact.fullName}</b>
                                                    </>
                                                    : "NA") : <span class="label label-sm label-danger">{GetEBoolName(data.isOrder)}</span>}
                                            </td>
                                        </tr>
                                        {data.order && data.order.processingDistribution &&
                                            <tr>
                                                <td>{data.order.processingDistribution.processing.name}</td>
                                                <td colSpan={2}>
                                                    <>
                                                        To: <b>{data.order.processingDistribution.contact.fullName}, {data.order.processingDistribution.contact.address}</b>
                                                    </>
                                                </td>
                                            </tr>
                                        }
                                        <tr >
                                            <td>Note</td>
                                            <td colSpan={2}>
                                                {data.note ? data.note : "NA"}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>
                    }
                </PrintBranding>
            }
        </div>
    )
})
